import React from 'react';
import { Check } from 'lucide-react';
interface Option {
  id: string;
  name: string;
  description?: string;
  icon?: React.ReactNode;
}
interface OptionSelectorProps {
  options: Option[];
  selectedOption: string;
  onSelect: (option: string) => void;
  layout?: 'grid' | 'list';
  columns?: number;
}
export const OptionSelector: React.FC<OptionSelectorProps> = ({
  options,
  selectedOption,
  onSelect,
  layout = 'grid',
  columns = 3
}) => {
  if (layout === 'list') {
    return <div className="space-y-2 mb-6" data-id="element-762">
        {options.map(option => <div key={option.id} onClick={() => onSelect(option.id)} className={`p-3 rounded cursor-pointer transition-all duration-200 ${selectedOption === option.id ? 'bg-[#CDA735] text-white' : 'bg-white/5 text-white hover:bg-white/10'}`} data-id="element-763">
            <div className="flex items-center" data-id="element-764">
              {option.icon && <div className="mr-3" data-id="element-765">{option.icon}</div>}
              <span data-id="element-766">{option.name}</span>
              {selectedOption === option.id && <div className="ml-auto" data-id="element-767">
                  <Check className="h-4 w-4" data-id="element-768" />
                </div>}
            </div>
          </div>)}
      </div>;
  }
  return <div className={`grid grid-cols-1 md:grid-cols-${columns} gap-6 mb-10`} data-id="element-769">
      {options.map(option => <div key={option.id} onClick={() => onSelect(option.id)} className={`p-6 rounded-lg cursor-pointer transition-all duration-300 flex flex-col items-center text-center ${selectedOption === option.id ? 'bg-[#CDA735] text-white' : 'bg-white/10 text-white hover:bg-white/20'}`} data-id="element-770">
          {option.icon && <div className="mb-4 text-white" data-id="element-771">{option.icon}</div>}
          <h3 className="text-lg font-medium mb-2" data-id="element-772">{option.name}</h3>
          {option.description && <p className="text-sm opacity-80 mb-4" data-id="element-773">{option.description}</p>}
          {selectedOption === option.id && <div className="w-6 h-6 rounded-full bg-white flex items-center justify-center" data-id="element-774">
              <Check className="h-4 w-4 text-[#CDA735]" data-id="element-775" />
            </div>}
        </div>)}
    </div>;
};